<ifbp-dashboard-page-shell [page]="page$ | async" [asOfUtc]="(vm$ | async)?.asOfUtc ?? null">
  <ng-container *ngIf="vm$ | async as vm" [ngSwitch]="vm.state">
    <ifbp-trend-metrics-skeleton *ngSwitchCase="VmState.LOADING"></ifbp-trend-metrics-skeleton>
    <ifbp-snapshot-error-card *ngSwitchCase="VmState.ERROR" [message]="vm.errorMessage"></ifbp-snapshot-error-card>
    <div class="trend" *ngSwitchCase="VmState.DATA">
      <ifbp-trend-volume-chart [vm]="vm.data?.chart"></ifbp-trend-volume-chart>
      <section class="trend__tiles">
        <ifbp-trend-tile *ngFor="let tile of vm.data?.tiles; trackBy: trackByTile" [vm]="tile"></ifbp-trend-tile>
      </section>
    </div>
  </ng-container>
</ifbp-dashboard-page-shell>
